export default "/_next/static/images/2021-3x-b4d2db93818aa36c623b70d3b6a4e442.png";